/**
 * MercadoPago SDK Plugin
 *
 * Loads the MercadoPago SDK and provides the instance globally.
 * Uses the Fields API for secure, PCI-compliant credit card data collection.
 *
 * @see https://github.com/mercadopago/sdk-js
 */
import { isProduction } from "~/constants/common";

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig().public;
  const isMercadoPagoEnabled = runtimeConfig.APP_FLAGS.hasMercadoPagoPayment;
  const publicKey = runtimeConfig.APP_CUSTOMER.app_config.api_key_mercadopago_public;
  const locale = runtimeConfig.APP_CUSTOMER.default_language as ILocale;

  const mercadoPagoLocale = locale?.startsWith("es") ? "es-CL" : "en-US";

  if (!isMercadoPagoEnabled) {
    if (!isProduction) {
      console.warn("MercadoPago is not enabled");
    }

    return;
  }

  useHead({
    script: [
      {
        src: "https://sdk.mercadopago.com/js/v2",
        async: true,
        onload: () => {
          if (window.MercadoPago) {
            const mercadoPagoInstance = new window.MercadoPago(publicKey, {
              locale: mercadoPagoLocale,
            });
            nuxtApp.provide("mercadopago", mercadoPagoInstance);
          }
        },
        onerror: () => {
          console.error("Failed to load MercadoPago SDK");
        },
      },
    ],
  });
});
